import { useState } from 'react';
import awsconfig from '@/amplifyconfiguration.json';
import { Amplify } from 'aws-amplify';
import MyPage from '../components/Mypage';
import Layout from '@/features/reservation/components/Layout';
import { ReservationCancelDone } from '@/features/mypage/components/ReservationCancelDone';
import { ReservationChangeDone } from '@/features/mypage/components/ReservationChangeDone';
import { ReservationCancelDenied } from './ReservationChangeDenied';
import { PatientInformationForm, ReservationDateTimeForm } from '@/features/reservation';
import { PatientInformationChangeForm } from './PatientInformationChangeForm';
import { InputTokenForm } from './InputTokenForm';
import { useNavigate } from 'react-router';

Amplify.configure(awsconfig);

export function MypageForm() {
  const [activeStep, setActiveStep] = useState(0);
  const [currentState, setCurrentState] = useState({
    patientInformation: null,
    symptoms: null,
    symptomOthers: null,
    examinationMenuId: null,
    reservationDateTime: null,
    isFromMypage: false,
    reserveid: null
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [errorType, setErrorType] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const handlePatientInformationSet = (email: string, phoneNumber: string) => {
    setEmail(email);
    setPhoneNumber(phoneNumber);
  };
  const navigate = useNavigate();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const linkToMypage = () => setActiveStep(0);
  const toErrorPage = (errorMessage: string, errorType: string) => {
    setErrorMessage(errorMessage);
    setErrorType(errorType);
    setActiveStep(7);
  };

  switch (activeStep) {
    case 0:
      return (
        <Layout title="マイページ" linkToMypage={linkToMypage} backButton handleBack={() => navigate(-1)}>
          <MyPage
            handleNext={handleNext}
            handleBack={handleBack}
            currentState={currentState}
            setCurrentState={setCurrentState}
            setActiveStep={setActiveStep}
            toErrorPage={toErrorPage}
          />
        </Layout>
      );
    case 1:
      return (
        <Layout title="キャンセル完了" handleBack={handleBack} backButton={true} linkToMypage={linkToMypage}>
          <ReservationCancelDone linkToMypage={linkToMypage} />
        </Layout>
      );
    // case 2:
    // 診療メニュー選択ページ（ExaminationMenuForm）があったが、/patient/facility?fid=~~に遷移させるようにしている
    // 今は使っていない
    case 3:
      return (
        <Layout title="予約日時選択" backButton={true} handleBack={() => setActiveStep(0)} linkToMypage={linkToMypage}>
          <ReservationDateTimeForm
            isLogin={true}
            handleNext={handleNext}
            currentState={currentState}
            setCurrentState={setCurrentState}
            setActiveStep={setActiveStep}
            toErrorPage={toErrorPage}
          />
        </Layout>
      );
    // case 4:
    // 診療メニュー選択ページ（ReservationDone）があった。今は使ってない
    case 5:
      return (
        <Layout title="ご予約変更完了" linkToMypage={linkToMypage}>
          <ReservationChangeDone currentState={currentState} />
        </Layout>
      );
    case 6:
      return (
        <Layout title="お客様情報登録" handleBack={handleBack} linkToMypage={linkToMypage}>
          <PatientInformationForm
            handleNext={handleNext}
            handleBack={handleBack}
            currentState={currentState}
            setCurrentState={setCurrentState}
            setActiveStep={setActiveStep}
          />
        </Layout>
      );
    case 7:
      return (
        <Layout title="ご予約情報変更" handleBack={handleBack} linkToMypage={linkToMypage}>
          <ReservationCancelDenied setActiveStep={setActiveStep} errorMessage={errorMessage} errorType={errorType} />
        </Layout>
      );
    case 8:
      return (
        <Layout title="お客様情報編集" handleBack={handleBack} linkToMypage={linkToMypage}>
          <PatientInformationChangeForm
            handleNext={handleNext}
            handleBack={handleBack}
            currentState={currentState}
            setCurrentState={setCurrentState}
            setActiveStep={setActiveStep}
            onPatientInformationSet={handlePatientInformationSet}
            linkToMypage={linkToMypage}
          />
        </Layout>
      );
    case 9:
      return (
        <Layout title="お客様情報編集" handleBack={handleBack} linkToMypage={linkToMypage}>
          <InputTokenForm
            handleNext={handleNext}
            handleBack={handleBack}
            currentState={currentState}
            setCurrentState={setCurrentState}
            setActiveStep={setActiveStep}
            email={email}
            phoneNumber={phoneNumber}
            linkToMypage={linkToMypage}
          />
        </Layout>
      );
    default:
      return 'Not found';
  }
}

export default MypageForm;
